/**
 * <strong>Purpose:</strong> <br>
 * This mixin provides a method to return the nodes where title attribute could be added.
 * <br><br>
 * <strong>Contract:</strong> <br>
 * The widget should have buttonNode and focusNode.
 *
 * @module MW/toolstrip/form/mixins/property/DropDownButtonTooltipMixin
 *
 * @copyright Copyright 2019 The MathWorks, Inc.
 */

define([
    "dojo/_base/declare"
], function (declare) {
    return declare(null, {
        /**
         * Get the array of title nodes.
         * @returns {Array}
         */
        getTitleNodes: function() {
            return [this.buttonNode, this.focusNode];
        }
    });
});
